import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiPinflGet } from '@/entities/pinfl/modules/api/pinfl';
import { env } from '@/shared/lib/env';

/**
 * PINFL limit status. ``excludeParcel`` returns a baseline without that
 * parcel (its products and split allocations) for editors that add a live
 * form total on top; see ``isCountedInLimit``.
 */
export const usePinflLimit = (pinfl: string, excludeParcel?: string) => {
  const isComplete = pinfl.length === env.pinflLength && /^\d+$/.test(pinfl);
  return useFetch({
    api: () => apiPinflGet(pinfl, excludeParcel),
    keywords: queryKeys.pinfl.detail(pinfl, excludeParcel),
    enabled: isComplete,
    staleTime: 30_000,
  });
};
